import { create } from 'zustand';

const STORAGE_KEY = 'ticket_last_seen_at';

interface TicketNotificationState {
  hasUnseenActivity: boolean;
  setHasUnseenActivity: (value: boolean) => void;
  /** Mark tickets as seen now */
  markAsSeen: () => void;
  /** Get the last-seen timestamp */
  getLastSeenAt: () => string;
}

export const useTicketNotificationStore = create<TicketNotificationState>((set) => ({
  hasUnseenActivity: false,
  setHasUnseenActivity: (value) => set({ hasUnseenActivity: value }),
  markAsSeen: () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    set({ hasUnseenActivity: false });
  },
  getLastSeenAt: () => {
    return localStorage.getItem(STORAGE_KEY) || new Date(0).toISOString();
  },
}));
